import { BookOpenCheckIcon, CalculatorIcon, ClipboardCheckIcon, FactoryIcon, ShieldCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Industrial Chemistry Technical Dictionary',
    description: '160 essential chemistry, equipment, control, and manufacturing terms explained.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '2',
    title: 'Chemical Process Calculations & Formulas Companion',
    description: '24 worked engineering examples covering stoichiometry, flow, energy, and efficiency calculations.',
    icon: CalculatorIcon,
  },
  {
    number: '3',
    title: 'Chemical Plant Equipment Reference Handbook',
    description: '45 equipment categories with operating principles and common performance issues.',
    icon: FactoryIcon,
  },
  {
    number: '4',
    title: 'Real-World Chemical Industry Case Studies',
    description: '12 industrial process scenarios with technical analysis and practical lessons.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '5',
    title: 'Industrial Chemical Safety & Quality Reference Guide',
    description: 'Chemical hazards, safe practices, quality principles, and 6 safety/quality scenarios.',
    icon: ShieldCheckIcon,
  },
];
